import Unavailable from "../../../assets/images/unavailable.png";

export default function UnAvailable() {
    return (
        <div className="d-flex justify-content-center align-items-center vh-100">

            <div className="text-center p-4">
            
                <div className="mb-4 text-secondary">
                <img
                      className="unavailable-img"
                      src={Unavailable}
                      alt="Unavailable"
                      loading="lazy"
                    />
                </div>
                <h3 className="fw-bold mb-3">We’re Making Some Updates!</h3>

                <p className="mb-4 fs-6">
                    This section is currently unavailable as we’re aligning with Google Play policies.
                    Please check back soon.
                </p>
                <button type="button" className="btn btn-light btn-text">Currently Unavailable</button>
                {/* <p className="mt-4 fs-8">
                    Please contact our customer support team at <strong>customercare@nureca.com</strong> or
                    by calling helpline no <strong>+917527013265</strong> or chat with us - <strong>+917527013265</strong>
                </p> */}
            </div>

            </div>
    )
}